module.exports = __webpack_public_path__ + "static/media/Color.b105fedc.gif";